import { render, staticRenderFns } from "./desc.vue?vue&type=template&id=62452d79&scoped=true&"
import script from "./desc.vue?vue&type=script&lang=js&"
export * from "./desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62452d79",
  null
  
)

export default component.exports